import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Mobile = ({
  size,
  type,
  theme,
  className,
  dataTestId = "mobile-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2.713C3 1.767 3.753 1 4.683 1h6.732c.929 0 1.682.767 1.682 1.713v10.999c0 .946-.753 1.713-1.682 1.713H4.683c-.93 0-1.683-.767-1.683-1.713V2.713Zm1.683-.571a.566.566 0 0 0-.561.571v10.999c0 .315.251.57.56.57h6.732c.31 0 .562-.255.562-.57V2.713a.566.566 0 0 0-.562-.571h-1.121v.748a.721.721 0 0 1-.722.722H6.526a.721.721 0 0 1-.721-.722v-.748H4.683Z"
    />
  </SVGIcon>
);
